"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProgressStep;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("../ProgressIndicator/context");

var _doneIcon = _interopRequireDefault(require("./doneIcon"));

var _errorIcon = _interopRequireDefault(require("./errorIcon"));

var _step = _interopRequireDefault(require("./styled/step"));

var _stepButton = _interopRequireDefault(require("./styled/stepButton"));

var _inactiveIcon = _interopRequireDefault(require("./styled/inactiveIcon"));

var _activeIcon = _interopRequireDefault(require("./styled/activeIcon"));

var _label = _interopRequireDefault(require("./styled/label"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var iconMap = {
  Error: function Error() {
    return /*#__PURE__*/_react["default"].createElement(_errorIcon["default"], null);
  },
  Completed: function Completed() {
    return /*#__PURE__*/_react["default"].createElement(_doneIcon["default"], null);
  },
  Active: function Active() {
    return /*#__PURE__*/_react["default"].createElement(_activeIcon["default"], null);
  },
  Inactive: function Inactive() {
    return /*#__PURE__*/_react["default"].createElement(_inactiveIcon["default"], null);
  }
};

var StepItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(StepItem, _Component);

  var _super = _createSuper(StepItem);

  function StepItem(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, StepItem);
    _this = _super.call(this, props);
    _this.handleOnClick = _this.handleOnClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setStepState = _this.setStepState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      stepState: 'Inactive'
    };
    return _this;
  }

  (0, _createClass2["default"])(StepItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          privateRegisterStep = _this$props.privateRegisterStep,
          name = _this$props.name;
      return setTimeout(function () {
        return privateRegisterStep({
          name: name,
          onSetStepState: _this2.setStepState
        });
      }, 0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevCurrentStepName = _ref.currentStepName;
      var _this$props2 = this.props,
          currentStepName = _this$props2.currentStepName,
          name = _this$props2.name;
      var setChildrenState = this.props.setChildrenState;

      if (prevCurrentStepName !== currentStepName) {
        setChildrenState({
          name: name,
          onSetStepState: this.setStepState
        });
      }
    }
  }, {
    key: "setStepState",
    value: function setStepState(stepState) {
      var hasError = this.props.hasError;

      if (hasError) {
        return this.setState({
          stepState: 'Error'
        });
      }

      return this.setState({
        stepState: stepState
      });
    }
  }, {
    key: "getAssistiveText",
    value: function getAssistiveText() {
      var label = this.props.label;
      var stepState = this.state.stepState;

      if (label && stepState !== 'Inactive') {
        return "".concat(label, " - ").concat(stepState);
      }

      if (label) {
        return label;
      }

      if (stepState) {
        return stepState;
      }

      return '';
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var stepState = this.state.stepState;

      if (iconMap[stepState]) {
        return iconMap[stepState]();
      }

      return null;
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick(event) {
      var _this$props3 = this.props,
          privateOnClick = _this$props3.privateOnClick,
          name = _this$props3.name;
      return privateOnClick(event, name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          label = _this$props4.label,
          className = _this$props4.className;
      var stepState = this.state.stepState;
      return /*#__PURE__*/_react["default"].createElement(_step["default"], {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(_stepButton["default"], {
        stepState: stepState,
        icon: this.getIcon(),
        onClick: this.handleOnClick,
        assistiveText: this.getAssistiveText()
      }), /*#__PURE__*/_react["default"].createElement(_label["default"], {
        stepState: stepState
      }, label));
    }
  }]);
  return StepItem;
}(_react.Component);

function ProgressStep(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/_react["default"].createElement(_context.Consumer, null, function (context) {
    return /*#__PURE__*/_react["default"].createElement(StepItem, (0, _extends2["default"])({}, props, context));
  });
}

ProgressStep.propTypes = {
  /** The name is used to determine which ProgressStep is active. */
  name: _propTypes["default"].string,

  /** Text label for the ProgressStep. */
  label: _propTypes["default"].node,

  /** Indicates whether the current step is in error state and displays a warning icon
   * on the step indicator. This value defaults to false. */
  hasError: _propTypes["default"].bool,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
ProgressStep.defaultProps = {
  name: '',
  label: '',
  hasError: false,
  className: undefined,
  style: undefined
};